/**
 * Brand Zone (Brand Hub) model interfaces
 */

export interface BrandZoneType {
  id: number;
  title: string;
  sub_type_code?: string;
}

export interface BrandZone {
  id: number;
  title: string;
  description?: string;
  thumbnail?: string;
  image_video_url?: string;
  external_url?: string;
  start_date?: string;
  end_date?: string;
  status?: number | string;
  status_title?: string;
  program_id?: number;
  brand_hub_type?: number | string;
  brand_hub?: string;
  is_all_users?: number | string;
  is_slide?: number | string;
  excel_url?: string | null;
  external_url_title?: string;
  pdf_link?: string;
}

export interface BrandZoneListQuery {
  program_id: number;
  brand_hub_type?: string | number;
  search?: string;
  page?: number;
  page_size?: number;
}

export interface BrandZonePaginationMeta {
  page?: number;
  page_size?: number;
  total_count?: number;
  total_pages?: number;
  has_next?: boolean;
  has_previous?: boolean;
}

export interface BrandZoneUploadStatus {
  total?: number;
  success?: number;
  reject_count?: number;
  reject?: Array<{ number?: string; rejected_message?: string }>;
}

export interface BrandZoneCreatePayload {
  brand_hub_type: number;
  title: string;
  description: string;
  start_date: string;
  end_date: string;
  is_all_users: number;
  external_url: string;
  image_video_url: string;
  thumbnail?: string;
  is_slide?: number | string;
  brand_hub_id?: number | string;
  excel_data?: File | '';
}

export interface BrandZoneUpdatePayload extends BrandZoneCreatePayload {
  program_id: number;
  brand_hub_id: number;
  status: number;
}

export interface BrandZoneDeletePayload {
  program_id: number;
  brand_hub_id: number;
}

export interface BrandZoneWhitelistUser {
  id: number;
  mobile?: string;
  number?: string;
  outlet_code?: string;
  status?: number | string;
  user_id?: number;
}

export interface BrandZoneWhitelistQuery {
  brand_hub_id: number;
  mobile?: string;
  outlet_code?: string;
  page?: number;
  search?: string;
}
